import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { DealerUserStatusName } from '../constants/UserStatus';
import editIcon from '../assets/img/icons/edit-primary.svg';

function DealersTableRow({ item }) {
  const {
    id,
    officialCompanyName,
    tradeName,
    mainEmail,
    phoneNumber,
    status,
    averagePurchaseFrequencyByWeek,
    averagePurchaseFrequencyByMonth,
  } = item;

  return (
    <>
      <td>{officialCompanyName ?? '-'}</td>
      <td>{tradeName ?? '-'}</td>
      <td>{mainEmail}</td>
      <td>{phoneNumber ?? '-'}</td>
      <td>{DealerUserStatusName[status]}</td>
      <td>{averagePurchaseFrequencyByWeek}</td>
      <td>{averagePurchaseFrequencyByMonth}</td>
      <td className="text-right">
        <Button
          className="btn-icon rounded-circle btn-ghost-light"
          id={`tooltip_edit${id}`}
          size="sm"
          type="button"
        >
          <img src={editIcon} alt="Edit icon" />
        </Button>
        <UncontrolledTooltip
          delay={0}
          className="uncontrolled-tooltip"
          target={`tooltip_edit${id}`}
        >
          Edit
        </UncontrolledTooltip>
      </td>
    </>
  );
}

DealersTableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default DealersTableRow;
